import { v4 as uuidv4 } from 'uuid';
/**
 * 统一发送IWiki消息的方法
 * @param type 消息类型：'chatLoaded' | 'sendMsgId' | 'sendStatusData' | 'sendSession' | 'retrySession'
 * @param payload 消息负载，根据不同类型有不同的结构
 * @param options 可选参数，包括消息id和来源
 */

export const sendIWikiMessage = <O extends Record<string, any>>({
  type,
  payload,
  options,
}: {
  options?: {
    id?: string;
    source?: string;
    restParams?: O;
  };
  type:
  | 'chatLoaded'
  | 'sendMsgId'
  | 'sendStatusData'
  | 'sendSession'
  | 'retrySession';
  payload: O;
}) => {
  const defaultSource = 'databrain';
  const { id, restParams } = options || {};
  const message = {
    action: type,
    id: id || uuidv4(),
    payload,
    source: options?.source || defaultSource,
    ...restParams,
  };

  window.parent.postMessage(message, '*');
};
